import http from '@/utils/http'

const initialState = () => ({
  list: [],
  jobsInGroup: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  },
  SET_JOBS_IN_GROUP (state, list) {
    state.jobsInGroup = list
  }
}

export const getters = {
  list: state => state.list,
  jobsInGroup: state => state.jobsInGroup
}

export const actions = {
  fetchGroups ({ commit, getters, rootGetters }, force = false) {
    if (!force && getters.list.length) {
      return getters.list
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}jobs/group/retrieveall/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}`
    }).then(data => {
      commit('SET_LIST', data)

      return data
    })
  },
  saveGroup ({ commit, rootGetters }, data) {
    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}jobs/group/save/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}`,
      data
    }).catch(e => {
      throw e
    })
  },
  removeGroup ({ commit, rootGetters }, id) {
    return http({
      url: `${process.env.VUE_APP_API_URL}jobs/group/delete/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${id}`
    })
  },
  addJobToAGroup ({ commit, rootGetters }, { jobId, groupId }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}jobs/group/addjob/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${groupId}/${jobId}`
    })
  },
  fetchJobsInAGroup ({ commit, rootGetters }, groupId) {
    return http({
      url: `${process.env.VUE_APP_API_URL}jobs/group/jobsingroup/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${groupId}`
    })
      .then((list) => {
        commit('SET_JOBS_IN_GROUP', list)

        return list
      })
  },
  removeJobFromGroup ({ commit, rootGetters }, { jobId, groupId }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}jobs/group/removejob/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${groupId}/${jobId}`
    })
  }
}
